// CartIcon.js
import React from 'react';

const CartIcon = () => (
  <svg
  id="shopping-cart-icon"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="var(--icon-color)"
  strokeWidth="2.5"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <circle cx="9" cy="21" r="1.5" />
  <circle cx="20" cy="21" r="1.5" />
  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
</svg>

);

export default CartIcon;
